"use strict";

var React = require('react');

var DragHandle = require('../dragHandle.svg.js');

var _Symbol = require('../symbol');

var Tooltip = require('../tooltip');

module.exports = function (props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('sbdl-item-row-base') + (props.dragHandle ? ' has-drag-handle' : '') + (props.dragHandleEnabled ? '' : ' disabled-drag-handle')
  }, props.dragHandleTooltipContent && props.dragHandle ? /*#__PURE__*/React.createElement("div", {
    key: "itemRowDragHandle",
    className: "drag-handle-container"
  }, /*#__PURE__*/React.createElement(_Symbol, {
    className: "symbol-dragHandle"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    className: "dragHandle-tooltip",
    content: props.dragHandleTooltipContent,
    shouldTranslate: false,
    isOpen: props.isDragging
  }, /*#__PURE__*/React.createElement(DragHandle, null)))) : null, props.dragHandle && !props.dragHandleTooltipContent ? /*#__PURE__*/React.createElement("div", {
    key: "itemRowDragHandle",
    className: "drag-handle-container"
  }, /*#__PURE__*/React.createElement(_Symbol, {
    className: "symbol-dragHandle"
  }, /*#__PURE__*/React.createElement(DragHandle, null))) : null, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, props.children));
};